module.exports = __webpack_public_path__ + "mInboxAirbnbIcon.png?e0c6ad3a352d0d7fede7c18a6b258cc9";